export enum AttributeStatusEnum {
  new = 'New',
  changed = 'Changed',
  current = 'Current'
}
